export default function TermsOfUse() {
  return (
    <div className="max-w-[720px] mx-auto px-6 py-16 text-[#1d1d1f]">
      <h1 className="text-4xl font-semibold mb-2" style={{ letterSpacing: "-0.025em" }}>Terms of Use</h1>
      <p className="text-[#6e6e73] text-sm mb-10">Last updated: September 2026</p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">About NC Desi</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          NC Desi is a community platform for the Indian diaspora in North Carolina. By using this site you agree to these terms. If you disagree, please do not use the site.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Your content</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80 mb-3">
          You are responsible for any content you submit. By posting on NC Desi, you confirm that your content:
        </p>
        <ul className="list-disc list-inside space-y-1.5 text-[15px] text-[#1d1d1f]/80">
          <li>Is accurate and not misleading</li>
          <li>Does not infringe anyone else's intellectual property</li>
          <li>Does not contain harassment, hate speech, or illegal material</li>
          <li>Is not spam, MLM, or unsolicited commercial promotion</li>
        </ul>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80 mt-3">
          We reserve the right to remove any content and ban any user who violates these rules.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Moderation</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          All submissions go through a review process before appearing publicly. NC Desi is not responsible for the accuracy of user-submitted content, including housing listings, job postings, or event details. Always verify independently before acting on any listing.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Housing & job listings</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          NC Desi is a free community board — not a licensed real estate agent or employment agency. We do not verify the accuracy of housing or job listings, and we are not a party to any transaction. Always exercise caution and meet in safe, public places.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Availability</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          NC Desi is provided "as is" with no guarantees of uptime, data retention, or feature availability. We may modify, suspend, or discontinue the service at any time.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Limitation of liability</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          NC Desi and its operators are not liable for any damages arising from your use of this platform, including transactions with other community members. Use the site at your own risk.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Governing law</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          These terms are governed by the laws of the State of North Carolina, USA.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">Contact</h2>
        <p className="text-[15px] leading-relaxed text-[#1d1d1f]/80">
          Questions? Email <a href="mailto:dheerajgadikota@gmail.com" className="text-[#0071e3]">dheerajgadikota@gmail.com</a>.
        </p>
      </section>

      <a href="/" className="text-[#0071e3] text-sm hover:underline">← Back to NC Desi</a>
    </div>
  );
}
